import { SLUG_PATTERN } from '../constants.js';

export function isValidSlug(slug: string): boolean {
  return SLUG_PATTERN.test(slug);
}

/** Kebab-case an app name into a platform slug (max 40 chars). */
export function deriveSlug(name: string): string {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 40)
    .replace(/-+$/g, '');
}

export function slugError(slug: string): string | null {
  if (isValidSlug(slug)) return null;
  return `"${slug}" is not a valid slug — use lowercase letters, digits and hyphens (start/end alphanumeric, max 40 chars).`;
}
